import type { FilePath, GitDiff } from '../../models/git-worker.model';
import type { WasmGitModule, WorkerAction, WorkerFnParams } from '../../wasm-git.worker.model';
import { WorkerActionError } from '../../wasm-git.worker.model';
import type { GitAction } from '../actions.enum';
import { DiffParser } from './diff-parser';

export interface GitDiffAction extends WorkerAction {
  type: GitAction.Diff;
  params: {
    fromSha: string;
    toSha: string;
    path?: FilePath;
  };
}

export class GitDiffActionError extends WorkerActionError {}

const parser = new DiffParser();

export async function GitDiffActionFn({ lg, params, util }: WorkerFnParams<GitDiffAction>): Promise<GitDiff[]> {
  let output = '';
  try {
    output = lg.callAndCaptureOutput(['diff', params.fromSha, params.toSha]);

    let diffs = parser.parse(output);
    if (params.path) {
      const isFile = util.isFile(params.path);
      diffs = diffs.filter((diff) => (isFile ? diff.path === params.path : diff.path.startsWith(params.path!)));
    }
    return Promise.all(
      diffs.map(async (diff) => ({
        ...diff,
        fileContents: await Promise.all([catFile(diff.oldHash, lg), catFile(diff.newHash, lg)]),
      })),
    );
  } catch (err) {
    throw new GitDiffActionError(err);
  }
}

function catFile(sha: string, lg: WasmGitModule) {
  return sha === '0000000' ? Promise.resolve('') : lg.callAndCaptureOutput(['cat-file', '-p', sha]);
}
